// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1K9Vb","list":"BalanceDue_list__2WUkx","listRow":"BalanceDue_listRow__3gJo1","total":"BalanceDue_total__3k5uS"};